import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';
import {
  FiltersListSkeleton,
  RecommendationsFilters,
} from '@/features/recommend/components/recommendationsFilters';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';
import { Button } from '@/shared/components/ui/button';
import { Skeleton } from '@/shared/components/ui/skeleton';

export const Route = createFileRoute('/_protected/_app/_mainLayout/filters')({
  loader: ({ context }) => {
    void context.queryClient
      .ensureQueryData(getMyProfileOptions())
      .then(data => {
        if (data.profile?.riotPuuid) {
          void context.queryClient.prefetchQuery(
            getValorantPlayerOptions({ puuid: data.profile.riotPuuid }),
          );
        }
      });
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function PendingComponent() {
  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <Skeleton className="size-6 rounded" />
        <Skeleton className="h-8 w-14 rounded" />
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-7 w-16" />
            <Skeleton className="h-10 w-full" />
          </div>
          <FiltersListSkeleton />
        </div>
      </MainLayout.Content>
    </MainLayout.Root>
  );
}

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/' });
  });

  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <PageHeader.BackButton onClick={handleGoBack} />
        <Button onClick={handleGoBack} size="sm">
          Done
        </Button>
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <RecommendationsFilters />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
